import { DEFAULT_CONFIGURATION } from "../constants/defaultConfiguration";

// Update configuration with default values for dimensions
// where user input has not been set at the moment
export default function setDefaultValues(configuration) {
  Object.keys(configuration).forEach(input => {
    if (!configuration[input]) {
      switch (input) {
        case "type":
          configuration.type = DEFAULT_CONFIGURATION.TYPE;
          break;
        case "size":
          configuration.size = DEFAULT_CONFIGURATION.SIZE[configuration.type];
          break;
        case "season":
          configuration.season = DEFAULT_CONFIGURATION.SEASON;
          break;
        case "foundation":
          configuration.foundation = DEFAULT_CONFIGURATION.FOUNDATION;
          break;
        case "constructionSupport":
          configuration.constructionSupport =
            DEFAULT_CONFIGURATION.CONSTRUCTION_SUPPORT;
          break;
      }
    }
  });
}
